import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';

export const loadPageTraitOptions = async (projectId, version) => {
  const header = builderSurfaceJsonContentHeader(projectId);
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${projectId}/project`;
  const pageResponse = await axios.get(url, header);
  let options = [{ id: '', name: 'None' }];
  if (pageResponse.data) {
    options = options.concat(
      pageResponse.data.map((item, key) => {
        if (item.collectionId) {
          return {
            id: '/' + item.slug,
            name: item.name,
            collectionId: item.collectionId,
          };
        } else {
          return {
            id: '/' + item.slug,
            name: item.name,
          };
        }
      }) || [],
    );
  }
  return options;
};
